module.exports = __webpack_public_path__ + "assets/favicon-bf-it.cf7733eb.png";